
import { toast } from 'react-toastify';
import React, { useState, useEffect } from "react";
import API from "../../Network/API";
import { Link } from "react-router-dom";
import AddMeetingSchedule from "../Modal/AddMeetingSchedule";
import MeetingShare from "../Modal/MeetingShare";
import ContentLoader from "react-content-loader"
import ShareMeeting from '../Modal/ShareMeeting';
import { useSelector } from 'react-redux';
import EditMeeting from '../Modal/EditMeeting';
import { useTranslation } from "react-i18next";

toast.configure();
export default function Meeting() {
    const { t } = useTranslation()
    const [meetingId, setMeetingId] = useState('');
    const [loading, setLoading] = useState(false);
    const [modalDialog, setModalDialog] = useState(false);
    const [addModalDialog, setAddModalDialog] = useState(false);
    const [sendToShareData, setSendToShareData] = useState(null);
    const [meetingList, setMeetingList] = useState([]);

    const [isMeetingLoading, setMeetingLoading] = useState(false);
    const [demo_data, setDatas] = useState([{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5 }, { id: 6 }, { id: 7 }, { id: 8 }, { id: 9 }, { id: 10 }]);
    const [progress, setProgress] = useState(false);
    const [isFetching, setIsFetching] = useState(false);
    const [page, setPage] = useState(1);
    const [next_page, setNextPage] = useState('/v1/upcoming_meeting_all');
    const [nextPageUrl, setNextPageURL] = useState(null);
    const [lengthData, setDataLength] = useState(0);
    const myArr = JSON.parse(localStorage.getItem('user_data'));
    const [modalDialogShare, setModalDialogShare] = useState(false);
    const [sc_meet, setScMeet] = useState(null);
    const [edit_modalDialog, setEditModalDialog] = useState(false);
    const usert_timez = useSelector((state) => state.timeZoneReducer)
    const toggleModalSahre = (meeting_room) => {
        setScMeet(meeting_room)
        setModalDialogShare(!modalDialogShare)
    };

    const toggleEditMeeting = (meeting_room) => {
        setScMeet(meeting_room)
        setEditModalDialog(!modalDialog)
    };

    useEffect(() => {
        fetchRepositories()
    }, []);

    function fetchRepositories() {

        setProgress(true)

        API.get(next_page, {
            'offset': meetingList.length
        }).then((response) => {

            const paginator = response.data.data;

            setMeetingList(response.data.data.meeting_data)
            setProgress(false)
            setNextPageURL(paginator.next_page_url)
            setPage((page + 1))


        }).catch((error) => {
            setProgress(true)

        });

    }

    const toggleModal = () => {
        setModalDialog(!modalDialog)
    };

    const toggleModal1 = () => {
        setAddModalDialog(!addModalDialog)
    };

    const _new_meeting = () => {
        setLoading(true);
        API.get(`/v2/createRoomJson?timezone=${usert_timez.timezone}&datetime=${usert_timez.datetime}`).then(res => {
            setSendToShareData(res.data)
            toggleModal()
            // _start_meeting(res.data.room);
        });
    }
    const _start_meeting = (meeting_id) => {
        if (meeting_id) {
            window.location.href = "/meeting/" + meeting_id;
        } else {
            toast.error("Please enter meeting id");
        }
    }

    function scheduleStart(meeting_id) {
        API.get('/meeting/' + meeting_id).then(res => {
            window.location.href = "/meeting/" + meeting_id;
        }).catch((e) => {
            // console.log(e);
        });
    }

    // const meeting_delete = (m_id) => {
    //     var result = window.confirm("Are you sure want to delete?");
    //     if (result == true) {
    //       setLoading(true)
    //       API.delete("/meeting_delete/" + m_id).then((response) => {
    //         setLoading(false)
    //         if (response.data.success === true) {
    //           toast.success('delete successfully');
    //         }
    //       });
    //     }

    //   }
    return (
        <>
            <div className="min-vh-100 bg-white">
                <div className="container py-4">
                    <div className="row justify-content-center">
                        <div className="col-lg-8 col-xl-7">
                            <div className="text-center mb-4">
                                <h2 className="fw-bold text-dark mb-1">Connects Meeting</h2>
                                <p className="text-muted">Start instant meetings or schedule for later</p>
                            </div>
                            
                            <div className="meeting-main-section">
                                <div className="mb-3">

                                    <div className="row g-2 mb-3">
                                        <div className="col-md-6">
                                            <div className="dropdown w-100">
                                                <button
                                                    type="button"
                                                    className="btn btn-dark w-100 py-2 px-3 rounded-2 dropdown-toggle d-flex align-items-center justify-content-center"
                                                    aria-expanded="false"
                                                    data-bs-toggle="dropdown"
                                                    id="dropdownMenuLink"
                                                    style={{ fontSize: '14px', fontWeight: '500' }}
                                                >
                                                    <i className="fa-solid fa-video me-2" style={{ fontSize: '12px' }}></i>
                                                    {t('New Meeting')}
                                                </button>
                                                <div className="dropdown-menu w-100 border-0 shadow rounded-2 mt-1">
                                                    <div className="p-2">
                                                        <a
                                                            onClick={() => _new_meeting()}
                                                            className="dropdown-item py-2 px-2 rounded-2 d-flex align-items-center hover-bg-light"
                                                            style={{ cursor: 'pointer', transition: 'all 0.2s ease' }}
                                                        >
                                                            <div className="me-2">
                                                                <div className="bg-light rounded-circle d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px' }}>
                                                                    <i className="fa-solid fa-play text-dark" style={{ fontSize: '11px' }}></i>
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <div className="fw-medium text-dark" style={{ fontSize: '16px' }}>{t('Start an instant meeting')}</div>
                                                                <div className="text-muted" style={{ fontSize: '12px' }}>Begin meeting right now</div>
                                                            </div>
                                                        </a>
                                                        <a
                                                            className="dropdown-item py-2 px-2 rounded-2 d-flex align-items-center hover-bg-light"
                                                            onClick={() => toggleModal1()}
                                                            style={{ cursor: 'pointer', transition: 'all 0.2s ease' }}
                                                        >
                                                            <div className="me-2">
                                                                <div className="bg-light rounded-circle d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px' }}>
                                                                    <i className="fa-solid fa-calendar-plus text-dark" style={{ fontSize: '11px' }}></i>
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <div className="fw-medium text-dark" style={{ fontSize: '16px' }}>{t('Create a meeting for later')}</div>
                                                                <div className="text-muted" style={{ fontSize: '12px' }}>Schedule and share meeting</div>
                                                            </div>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="d-flex gap-1">
                                                <input
                                                    type="text"
                                                    className="form-control py-2 px-3 rounded-2 flex-grow-1"
                                                    placeholder="Enter Meeting ID"
                                                    spellCheck="false"
                                                    value={meetingId}
                                                    onChange={(e) => setMeetingId(e.target.value)}
                                                    style={{ fontSize: '14px' }}
                                                />
                                                <button
                                                    type="button"
                                                    onClick={() => _start_meeting(meetingId)}
                                                    className={`btn ${meetingId === "" ? 'btn-outline-secondary' : 'btn-outline-dark'} px-3 rounded-2`}
                                                    disabled={meetingId === ""}
                                                    style={{ fontSize: '14px', fontWeight: '500', minWidth: '80px' }}
                                                >
                                                    <i className="fa-solid fa-arrow-right-to-bracket me-1" style={{ fontSize: '12px' }}></i>
                                                    {t('Join')}
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            {meetingList.length > 0 && (
                                <div className="mt-4">
                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                        <h4 className="fw-bold text-dark mb-0">{t('Upcoming Meetings')}</h4>
                                        <Link
                                            to="/meeting-history"
                                            className="btn btn-outline-dark rounded-pill px-3 py-1 d-flex align-items-center"
                                            style={{ fontSize: '12px', fontWeight: '500' }}
                                        >
                                            <i className="fa-solid fa-clock-rotate-left me-1" style={{ fontSize: '11px' }}></i>
                                            History
                                        </Link>
                                    </div>
                            {progress && demo_data?.map((post, i) => (
                                <div key={i} className="mb-2">
                                    <ContentLoader
                                        speed={2}
                                        width="100%"
                                        height={80}
                                        viewBox="0 0 100 80"
                                        backgroundColor="#f3f3f3"
                                        foregroundColor="#ecebeb"
                                        className="rounded-2"
                                    >
                                        <rect x="8" y="15" rx="6" ry="6" width="10" height="10" />
                                        <rect x="22" y="12" rx="3" ry="3" width="30" height="5" />
                                        <rect x="22" y="20" rx="2" ry="2" width="40" height="3" />
                                        <rect x="8" y="35" rx="3" ry="3" width="20" height="3" />
                                        <circle cx="12" cy="50" r="3" />
                                        <circle cx="20" cy="50" r="3" />
                                        <circle cx="28" cy="50" r="3" />
                                        <rect x="75" y="35" rx="3" ry="3" width="12" height="6" />
                                    </ContentLoader>
                                </div>
                            ))}
                            {!progress && meetingList?.map((value, index) => (
                                <div key={index} className="mb-2">
                                    <div className="bg-white border rounded-2 p-3 shadow-sm hover-shadow-md transition-all">
                                        <div className="d-flex align-items-center justify-content-between">
                                            <div className="d-flex align-items-center flex-grow-1">
                                                <div className="me-3 text-center">
                                                    <div className="bg-light rounded-2 px-2 py-1 d-flex flex-column align-items-center" style={{ minWidth: '55px' }}>
                                                        <div className="fw-bold text-dark" style={{ fontSize: '16px', lineHeight: '1' }}>
                                                            {value.day}
                                                        </div>
                                                        <div className="text-muted" style={{ fontSize: '10px', textTransform: 'uppercase', letterSpacing: '0.3px' }}>
                                                            {value.month}
                                                        </div>
                                                        <div className="text-primary fw-medium" style={{ fontSize: '10px' }}>
                                                            {value.time}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="flex-grow-1 min-w-0">
                                                    <div className="d-flex align-items-center mb-1">
                                                        <h6 className="fw-semibold text-dark mb-0 me-2" style={{ fontSize: '15px' }}>
                                                            {value.room_title}
                                                        </h6>
                                                        {value.is_repeated == 1 && (
                                                            <span 
                                                                className="badge bg-primary bg-opacity-10 text-primary rounded-pill px-2 py-1 d-flex align-items-center"
                                                                style={{ fontSize: '9px', fontWeight: '500' }}
                                                                title={`Recurring meeting - ${
                                                                    value.recurring_type == 1 ? 'Daily' : 
                                                                    value.recurring_type == 2 ? 'Weekly' : 
                                                                    value.recurring_type == 3 ? 'Monthly' : 
                                                                    'Custom'
                                                                }`}
                                                            >
                                                                <i className="fa-solid fa-repeat me-1" style={{ fontSize: '8px' }}></i>
                                                                {value.recurring_type == 1 ? 'Daily' : 
                                                                 value.recurring_type == 2 ? 'Weekly' : 
                                                                 value.recurring_type == 3 ? 'Monthly' : 
                                                                 'Recurring'}
                                                            </span>
                                                        )}
                                                    </div>

                                                    <div className="d-flex align-items-center justify-content-between">
                                                        <div className="d-flex align-items-center">
                                                            <div className="d-flex me-2">
                                                                {value.users.slice(0, 3).map((user, userIndex) => (
                                                                    <Link key={userIndex} to={`/contact/${user.id}`} className="me-1">
                                                                        <div
                                                                            className="rounded-circle border border-white shadow-sm"
                                                                            style={{
                                                                                width: '26px',
                                                                                height: '26px',
                                                                                backgroundImage: `url(${user.avatar})`,
                                                                                backgroundSize: 'cover',
                                                                                backgroundPosition: 'center',
                                                                                marginLeft: userIndex > 0 ? '-6px' : '0'
                                                                            }}
                                                                        />
                                                                    </Link>
                                                                ))}
                                                                {value.users.length > 3 && (
                                                                    <Link to={`/meeting-details/${value.room_name}`}>
                                                                        <div
                                                                            className="rounded-circle bg-light border border-white shadow-sm d-flex align-items-center justify-content-center text-muted fw-medium"
                                                                            style={{
                                                                                width: '26px',
                                                                                height: '26px',
                                                                                fontSize: '9px',
                                                                                marginLeft: '-6px'
                                                                            }}
                                                                        >
                                                                            +{value.users.length - 3}
                                                                        </div>
                                                                    </Link>
                                                                )}
                                                            </div>

                                                            {value.is_owner == 1 && (
                                                                <div className="d-flex gap-1">
                                                                    <button
                                                                        onClick={() => toggleModalSahre(value)}
                                                                        className="btn btn-light btn-sm rounded-circle d-flex align-items-center justify-content-center"
                                                                        style={{ width: '26px', height: '26px' }}
                                                                        title="Add participants"
                                                                    >
                                                                        <i className="fa-solid fa-user-plus text-muted" style={{ fontSize: '10px' }}></i>
                                                                    </button>
                                                                    <button
                                                                        onClick={() => toggleEditMeeting(value)}
                                                                        className="btn btn-light btn-sm rounded-circle d-flex align-items-center justify-content-center"
                                                                        style={{ width: '26px', height: '26px' }}
                                                                        title="Edit meeting"
                                                                    >
                                                                        <i className="fa-solid fa-edit text-muted" style={{ fontSize: '10px' }}></i>
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {/* <div className="text-muted mt-1" style={{ fontSize: '11px' }}>
                                                        Created {value.created_time}
                                                    </div> */}
                                                </div>
                                            </div>

                                            <div className="ms-2">
                                                <Link to={`/meeting-details/${value.room_name}`}>
                                                    <button className="btn btn-outline-dark rounded-pill px-3 py-1" style={{ fontSize: '12px', fontWeight: '500' }}>
                                                        <i className="fa-solid fa-arrow-right me-1" style={{ fontSize: '10px' }}></i>
                                                        {t('Details')}
                                                    </button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}


                                </div>
                            )}

                            {meetingList.length === 0 && !progress && (
                                <div className="text-center py-4 mt-4">
                                    <div className="mb-3">
                                        <i className="fa-solid fa-calendar-xmark text-muted" style={{ fontSize: '36px' }}></i>
                                    </div>
                                    <h5 className="fw-bold text-dark mb-2">No upcoming meetings</h5>
                                    <p className="text-muted mb-3" style={{ fontSize: '14px' }}>Start an instant meeting or schedule one for later</p>
                                    <div className="d-flex justify-content-center gap-2">
                                        <Link
                                            to="/meeting-history"
                                            className="btn btn-outline-dark rounded-pill px-3 py-2"
                                            style={{ fontSize: '13px', fontWeight: '500' }}
                                        >
                                            <i className="fa-solid fa-clock-rotate-left me-2" style={{ fontSize: '11px' }}></i>
                                            History
                                        </Link>
                                        <button
                                            onClick={() => toggleModal1()}
                                            className="btn btn-dark rounded-pill px-3 py-2"
                                            style={{ fontSize: '13px', fontWeight: '500' }}
                                        >
                                            <i className="fa-solid fa-calendar-plus me-2" style={{ fontSize: '11px' }}></i>
                                            Schedule Meeting
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <AddMeetingSchedule isModalVisible={addModalDialog} handleShowB={() => setAddModalDialog(false)} />
            <MeetingShare modalVisible={modalDialog} handleShow={() => setModalDialog(false)} shareData={sendToShareData} type={1} />
            <ShareMeeting isModalVisible={modalDialogShare} meetingRoom={sc_meet} handleShowB={() => setModalDialogShare(false)} />
            <EditMeeting isModalVisible={edit_modalDialog} meetingRoom={sc_meet} handleShowB={() => setEditModalDialog(false)} />
        </>
    )
}